export default "__VITE_ASSET__BnzrIxEV__"